var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about55"},[_vm._v(" fgf "),_c('h1',[_vm._v("This is an about page")])])}]

export { render, staticRenderFns }